<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnPopupartMeta" class="btn btn-block btn-primary float-sm-right" (click)="showInfoPopUp()" style="display:none">POP-UP</button>
        <div id="divArticleInfoMetadata" class="modal" [style.display]="showInfoMetadataModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="top:-15px;position:relative;">
                <ul class="nav nav-tabs nav-tabs-custom" id="tabULArtStatusMeta">
                  <li class="nav-item">
                    <a data-toggle="tab" href="#ArtStatus" class="nav-link active">
                      <h4 class="modal-title">Article Status</h4>
                    </a>
                  </li>
                  <li class="nav-item" [style.display]="checkMetadataShow ? 'block' : 'none'">
                    <a data-toggle="tab" href="#ArtMetadata" class="nav-link">
                      <h4 class="modal-title">Article Metadata Editing</h4>
                    </a>
                  </li>
                </ul>
                <div type="button" class="close" data-dismiss="modal" (click)="hideInfoMetaDataModal()">×</div>
              </div>
              <div class="modal-body" style="overflow: hidden !important; position: relative; top: -30px;" id="divArticleModule">

                <div class="row">
                  <div class="tab-content">
                    <div id="ArtStatus" class="tab-pane active">
                      <app-articleinfo></app-articleinfo>
                    </div>
                    <div id="ArtMetadata" class="tab-pane">

                      <div class="divTabContent">
                        <ul class="nav nav-tabs nav-tabs-custom" id="Tabul">
                          <li class="nav-item"><a data-toggle="tab" href="#MainTab" class="nav-link active">Main</a></li>
                          <li class="nav-item"><a data-toggle="tab" href="#SecondaryTab" class="nav-link">Secondary</a></li>
                          <li class="nav-item"><a data-toggle="tab" href="#AuthorTab" class="nav-link">Authors</a></li>
                          <li class="nav-item"><a data-toggle="tab" href="#FundingTab" class="nav-link">Funding</a></li>
                        </ul>
                        <br />
                        <div class="tab-content">
                          <div id="MainTab" class="tab-pane active">
                            <form #form="ngForm" id="frmMain" class="overflowY">
                              <div class="col-sm-12">
                                <div class="row">
                                  <div class="col-md-12" name="ArticleTitle">
                                    <div class="form-group">
                                      <label for="txtTitle">Title<em>*</em></label>
                                      <input class="form-control" type="text" maxlength="1000" id="txtTitle" required>
                                    </div>
                                  </div>

                                  <div class="col-md-12" name="ArticleShortTitle">
                                    <div class="form-group">
                                      <label for="txtShortTitle">Short Title</label>
                                      <input class="form-control" type="text" maxlength="1000" id="txtShortTitle" required>
                                    </div>
                                  </div>

                                  <div class="col-md-3" name="ArticleNo">
                                    <div class="form-group">
                                      <label for="txtArticleID">Article Id<em>*</em></label>
                                      <input class="form-control" type="text" maxlength="250" id="txtArticleID" required>
                                    </div>
                                  </div>
                                  <div class="col-md-3" name="Manuscript">
                                    <div class="form-group">
                                      <label for="txtManuscript">Manuscript ID<em>*</em></label>
                                      <input class="form-control" type="text" id="txtManuscript">
                                    </div>
                                  </div>

                                  <div class="col-md-3" name="Elocator">
                                    <div class="form-group">
                                      <label for="txtElocator">Elocator</label>
                                      <input class="form-control" type="text" id="txtElocator">
                                    </div>
                                  </div>


                                  <div class="col-md-3" name="JournalID">
                                    <div class="form-group">
                                      <label for="ddlJournal">Journal<em>*</em></label>
                                      <select id="ddlJournal" class="form-control" style="width: 100%;" onchange="$('#btnGetArticleType').trigger('click');">
                                        <option [value]="0" selected="selected">Select</option>
                                        <option *ngFor="let item of lJournalList" value={{item.ID}}>
                                          {{item.Acronym}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <button type="button" id="btnGetArticleType" (click)="getArticleTypeList()" style="display:none">GetArticleType</button>

                                  <div class="col-md-3" name="ArticleType">
                                    <div class="form-group">
                                      <label for="ddlArticleType">Article Type<em>*</em></label>
                                      <select id="ddlArticleType" class="form-control" style="width: 100%;">
                                        <option [value]="0" selected="selected">Select</option>
                                        <option *ngFor="let item of lArticleTypeList" value={{item.SNo}} [selected]="item.SNo==articleTypeSelected">
                                          {{item.TypeName}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                                  <div class="col-md-3" name="RelatedArticleType">
                                    <div class="form-group">
                                      <label>Related Article Type</label>
                                      <input class="form-control" type="text" id="txtRelatedArticleType">
                                    </div>
                                  </div>
                                  <div class="col-md-3" name="DOI">
                                    <div class="form-group">
                                      <label for="txtDOI">DOI<em>*</em></label>
                                      <input class="form-control" type="text" maxlength="1000" id="txtDOI">
                                    </div>
                                  </div>


                                  <div class="col-md-3" name="ReceivedDate">
                                    <div class="form-group">
                                      <label for="txtReceivedDt">Received<em>*</em></label>
                                      <input type="date" class="form-control" id="txtReceivedDt">
                                    </div>
                                  </div>

                                  <div class="col-md-3" name="ScheduleDate">
                                    <div class="form-group">
                                      <label for="txtScheduleDt">Schedule</label>
                                      <input type="date" class="form-control" id="txtScheduleDt">
                                    </div>
                                  </div>
                                  <div class="col-md-3" name="DueDate">
                                    <div class="form-group">
                                      <label for="txtDueDt">Due</label>
                                      <input type="date" class="form-control" id="txtDueDt">
                                      <!--</div>-->
                                    </div>
                                  </div>
                                  <div class="col-md-3" name="PubDate">
                                    <div class="form-group">
                                      <label for="txtPublDt">Pub-date</label>
                                      <input type="date" class="form-control" id="txtPublDt" name="changeValueMeta">
                                    </div>
                                  </div>
                                  <div class="col-md-3" name="EPubDate">
                                    <div class="form-group">
                                      <label for="txtEPublDt">EPub-date</label>
                                      <input type="date" class="form-control" id="txtEPublDt" name="changeValueMeta">
                                    </div>
                                  </div>
                                  <div class="col-md-3" name="FirstReleaseDate">
                                    <div class="form-group">
                                      <label for="txtPeerReview">First Release</label>
                                      <input type="date" class="form-control" id="txtFirstReleaseDate">
                                    </div>
                                  </div>

                                  <div class="col-md-3" name="HistoryReceived">
                                    <div class="form-group">
                                      <label for="txtPeerReview">MS Received (Peer Review)</label>
                                      <input type="date" class="form-control" id="txtPeerReview">
                                    </div>
                                  </div>
                                  <div class="col-md-3" name="HistoryRevised">
                                    <div class="form-group">
                                      <label for="txtHistoryRevisedDt">MS Revised (Peer Review)</label>
                                      <input type="date" class="form-control" id="txtHistoryRevisedDt">
                                    </div>
                                  </div>

                                  <div class="col-md-3" name="HistoryAccepted">
                                    <div class="form-group">
                                      <label for="txtAcceptedPublDt">MS Accepted (Peer Review)</label>
                                      <input type="date" class="form-control" id="txtAcceptedPublDt">
                                    </div>
                                  </div>

                                  <div class="col-md-3" name="Subject">
                                    <div class="form-group">
                                      <label for="ddlSubject">Subject<em>*</em></label>
                                      <select id="ddlSubject" class="form-control">
                                        <option [value]="0" selected="selected">Select</option>
                                        <option *ngFor="let item of lSubjectList" value={{item.Subject}}>
                                          {{item.Subject}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>

                                  <div class="col-md-1" name="Volume">
                                    <div class="form-group">
                                      <label for="txtVolume">Volume</label>
                                      <input class="form-control" type="text" maxlength="6" id="txtVolume" name="changeValueMeta">
                                    </div>
                                  </div>
                                  <div class="col-md-1" name="Issue">
                                    <div class="form-group">
                                      <label for="txtIssue">Issue</label>
                                      <input class="form-control" type="text" maxlength="6" id="txtIssue" name="changeValueMeta">
                                    </div>
                                  </div>
                                  <div class="col-md-1" name="MSPage">
                                    <div class="form-group">
                                      <label for="txtMsPage">MS Pages<em>*</em></label>
                                      <input class="form-control" type="text" maxlength="50" id="txtMsPage">
                                    </div>
                                  </div>


                                  <div class="col-md-1" name="ProofPage">
                                    <div class="form-group">
                                      <label for="txtProofPage">Proof Pages<em>*</em></label>
                                      <input class="form-control" type="text" maxlength="50" id="txtProofPage">
                                    </div>
                                  </div>
                                  <div class="col-md-1" name="StartPage">
                                    <div class="form-group">
                                      <label for="txtStartPage">Start Page</label>
                                      <input class="form-control" type="text" maxlength="50" id="txtStartPage">
                                    </div>
                                  </div>
                                  <div class="col-md-1" name="EndPage">
                                    <div class="form-group">
                                      <label for="txtEndPage">End Page</label>
                                      <input class="form-control" type="text" maxlength="50" id="txtEndPage">
                                    </div>
                                  </div>
                                  <div class="col-md-1" name="TableCount">
                                    <div class="form-group">
                                      <label for="txtTableCnt">Tables</label>
                                      <input class="form-control" type="text" maxlength="3" id="txtTableCnt">
                                    </div>
                                  </div>
                                  <div class="col-md-1" name="WordCount">
                                    <div class="form-group">
                                      <label for="txtWordCount">Words</label>
                                      <input class="form-control" type="text" maxlength="3" id="txtWordCount">
                                    </div>
                                  </div>
                                  <div class="col-md-1" name="ColorFigCount">
                                    <div class="form-group">
                                      <label for="txtColorFig">Color Figure</label>
                                      <input class="form-control" type="text" maxlength="3" id="txtColorFig">
                                    </div>
                                  </div>
                                  <div class="col-md-1" name="BWFigCount">
                                    <div class="form-group">
                                      <label for="txtBWFig">BW Figure</label>
                                      <input class="form-control" type="text" maxlength="3" id="txtBWFig">
                                    </div>
                                  </div>

                                  <div class="col-md-8" name="HandlingEditor">
                                    <div class="form-group">
                                      <label for="txtHandlingEditor">Handling Editor</label>
                                      <input class="form-control" type="text" maxlength="3" id="txtHandlingEditor">
                                    </div>
                                  </div>


                                  <div class="col-md-1" name="FigCount">
                                    <div class="form-group">
                                      <label for="txtTotalFig">Total Figure</label>
                                      <input class="form-control" type="text" maxlength="3" id="txtTotalFig">
                                    </div>
                                  </div>

                                  <div class="col-md-2" name="SpecialIssue">
                                    <div class="form-group">
                                      <label for="ddlSpecialIssue">SpecialIssue</label>
                                      <select id="ddlSpecialIssue" class="form-control" style="width: 100%;">
                                        <option *ngFor="let item of lSpecialIssueList" value={{item.Id}}>
                                          {{item.Type}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>

                                  <div class="col-md-10" name="SpecialIssueTitle">
                                    <div class="form-group">
                                      <label for="ddlSpecialIssueTitle">Special Issue Title</label>
                                      <select id="ddlSpecialIssueTitle" class="form-control">
                                        <option *ngFor="let item of ISpecialIssueTitle" value={{item.SpecialIssueTitle}}>
                                          {{item.SpecialIssueTitle}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>

                                  <div class="col-md-3" name="TargetDate">
                                    <div class="form-group">
                                      <label for="txtTargetDateDt">Target Date</label>
                                      <input type="date" class="form-control" id="txtTargetDateDt">
                                    </div>
                                  </div>

                                  <div class="col-md-3" name="Language">
                                    <div class="form-group">
                                      <label for="ddlLanguage">Language</label>
                                      <select id="ddlLanguage" class="form-control">
                                        <option [value]="0" selected="selected">Select</option>
                                        <option *ngFor="let item of lLanguageList" value={{item.ID}}>
                                          {{item.Language}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>

                                  <div class="col-md-3" name="Country">
                                    <div class="form-group">
                                      <label for="ddlCountry">Country</label>
                                      <select id="ddlCountry" class="form-control">
                                        <option [value]="0" selected="selected">Select</option>
                                        <option *ngFor="let item of lCountryList" value={{item.ID}}>
                                          {{item.CountryName}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>

                                </div>

                              </div>
                            </form>
                          </div>
                          <div id="SecondaryTab" class="tab-pane">
                            <form #form="ngForm" id="frmSecondary" class="overflowY">
                              <div class="row">
                                <div class="col-md-12" name="Copyright">
                                  <div class="form-group">
                                    <label>Copyright</label>
                                    <div class="form-control rounded-0" id="txtCopyright" style="height:auto"></div>
                                  </div>
                                </div>
                                <div class="col-md-12" name="License">
                                  <div class="form-group">
                                    <label for="txtLicense">License</label>
                                    <textarea class="form-control rounded-0" id="txtLicense" rows="2"></textarea>
                                  </div>
                                </div>

                                <div class="col-md-12" name="Overline">
                                  <div class="form-group">
                                    <label for="txtOverline">Overline</label>
                                    <textarea class="form-control rounded-0" id="txtOverline" rows="2"></textarea>
                                  </div>
                                </div>
                                <div class="col-md-12" name="Abstract">
                                  <div class="form-group">
                                    <label for="txtAbstract">Abstract</label>
                                    <textarea class="form-control rounded-0" id="txtAbstract" rows="2"></textarea>
                                  </div>
                                </div>
                                <div class="col-md-12" name="Teaser">
                                  <div class="form-group">
                                    <label for="txtTeaser">Teaser</label>
                                    <textarea class="form-control rounded-0" id="txtTeaser" rows="2"></textarea>
                                  </div>
                                </div>
                                <div class="col-md-12" name="EditorSummary">
                                  <div class="form-group">
                                    <label for="txtEditorSummary">Editor's Summary</label>
                                    <textarea class="form-control rounded-0" id="txtEditorSummary" rows="2"></textarea>
                                  </div>
                                </div>
                                <div class="col-md-12" name="ProductionNotes">
                                  <div class="form-group">
                                    <label for="txtProductionNotes">Production Notes</label>
                                    <textarea class="form-control rounded-0" id="txtProductionNotes" rows="10"></textarea>
                                  </div>
                                </div>

                              </div>
                            </form>
                          </div>
                          <div id="AuthorTab" class="tab-pane">
                            <form #form="ngForm" id="frmAuthor">
                              <div class="row">
                                <div class="col-12" style="text-align:right;">
                                  <button id='spAddAuthor' class="btn btn-outline-info waves-effect waves-light" (click)='addAuthor();' name="Authors">
                                    <i class='fa fa-plus-square' aria-hidden='true'></i>  Author
                                  </button>
                                </div>
                                <div class="col-md-12">
                                  <div class="form-group fixTableHead" id="divAuthorList">
                                    <table #dtAuthor class="display dataTable" style="width: 100%" id="tblAuthorList">
                                      <thead>
                                        <tr>
                                          <th>#</th>
                                          <th>Given Name</th>
                                          <th>Middle Name</th>
                                          <th>Surname</th>
                                          <th>Email</th>
                                          <th>Corr. Author</th>
                                          <th>Content Type</th>
                                          <th>Contrib Type</th>
                                          <th>Contrib Id Type</th>
                                          <th>Contrib Id</th>
                                          <th style="display: none">ORCID</th>
                                          <th style="display: none">ID</th>
                                          <th>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let author of lAuthorList;" [ngStyle]="{'background-color': (author.Corresp == true) ? 'lightblue':'white'}">
                                          <td>{{lAuthorList.indexOf(author) + 1}}</td>
                                          <td>{{author.Given_names}}</td>
                                          <td>{{author.Middlename}}</td>
                                          <td>{{author.Surname}}</td>
                                          <td>{{author.Email}}</td>
                                          <td>{{author.Corresp == true ? "Yes" : "No"}}</td>
                                          <td>{{author.Content_type}}</td>
                                          <td>{{author.Contrib_type}}</td>
                                          <td>{{author.Contrib_id_type}}</td>
                                          <td>{{author.Contrib_id}}</td>
                                          <td style="display: none">{{author.ORCID}}</td>
                                          <td style="display: none">{{author.ID}}</td>
                                          <td>
                                            <i class="bx bxs-edit-alt editIcon" title="Edit" (click)="showAuthorDetails(author,lAuthorList.indexOf(author)+1)"></i>&nbsp;
                                            <i class="bx bxs-trash deleteIcon" title="Delete" (click)="deleteAuthorDetails(author,lAuthorList.indexOf(author)+1)" name="Authors"></i>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div id="FundingTab" class="tab-pane">
                            <form #form="ngForm" id="frmFunding">
                              <div class="row">
                                <div class="col-12" style="text-align: right;">
                                  <button id='spAddFunding' class="btn btn-outline-info waves-effect waves-light" (click)='addFunding();' name="Funding">
                                    <i class='fa fa-plus-square' aria-hidden='true'></i>  Funding
                                  </button>
                                </div>
                                <div class="col-md-12">
                                  <div class="form-group fixTableHead" id="divFundingList">
                                    <table #dtFunding class="display dataTable" style="width: 100%">
                                      <thead>
                                        <tr>
                                          <th>#</th>
                                          <th>Award Group Id</th>
                                          <th>Award Id</th>
                                          <th>Institution Id</th>
                                          <th>Institution Type</th>
                                          <th>Institution</th>
                                          <th name="Funding">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let funding of lFundingList;">
                                          <td>{{lFundingList.indexOf(funding) + 1}}</td>
                                          <td>{{funding.AwardGroupId}}</td>
                                          <td>{{funding.AwardId}}</td>
                                          <td>{{funding.InstitutionId}}</td>
                                          <td>{{funding.InstitutionIdType}}</td>
                                          <td>{{funding.Institution}}</td>
                                          <td name="Funding">
                                            <i class="bx bxs-edit-alt editIcon" title="Edit" (click)="showFundingDetails(funding,lFundingList.indexOf(funding)+1)"></i>&nbsp;
                                            <i class="bx bxs-trash deleteIcon" title="Delete" (click)="deleteFundingDetails(funding,lFundingList.indexOf(funding)+1)"></i>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>

                      <div class="modal" id="myAuthorModal" [style.display]="showAuthorModal ? 'block' : 'none'">
                        <div class="modal-dialog modal-lg Author-modal">
                          <div class="modal-content" id="divAuthorCT">
                            <!-- Modal Header -->
                            <div class="modal-header">
                              <h4 class="modal-title">Author details</h4>
                              <div type="button" class="close" data-dismiss="modal" (click)="hideAuthorModal()">&times;</div>
                            </div>
                            <!-- Modal body -->
                            <div class="modal-body" id="divAuthorBody" style="overflow-x: scroll">
                              <div class="divTabContent">
                                <form #form="ngForm" id="frmAuthorInfo">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group" name="AUSurname">
                                          <label for="txtSurname">Surname<em>*</em></label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtSurname" required>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group" name="AUMiddleName">
                                          <label for="txtMiddleName">Middle Name</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtMiddleName" required>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group" name="AUGivenName">
                                          <label for="txtGivenName">Given Name<em>*</em></label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtGivenName" required>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group" name="AUEmail">
                                          <label for="txtAuthorEmail">Email<em>*</em></label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAuthorEmail" required>
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group" name="AUContribType">
                                          <label for="txtContribType">Contrib Type</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtContribType">
                                        </div>
                                      </div>
                                      <div class="col-md-2">
                                        <div class="form-group" name="AUContentType">
                                          <label for="ddlRole">Content Type</label>
                                          <select id="ddlRole" class="form-control " style="width: 100%;">
                                            <option value="Select">Select</option>
                                            <option value="Author">Author</option>
                                            <option value="Editor">Editor</option>
                                            <option value="Copyeditor">Copyeditor</option>
                                          </select>
                                        </div>
                                      </div>
                                      <button type="button" id="btnCorrespStatusChange" (click)="CheckCorrespSelect()" style="display:none"></button>
                                      <div class="col-md-2">
                                        <div class="form-group" name="AUCorrAuthor">
                                          <label for="ddlCorresAuthor">Corr.Author</label>
                                          <select id="ddlCorresAuthor" class="form-control" style="width: 100%;" onchange="$('#btnCorrespStatusChange').trigger('click');">
                                            <option [value]="false" selected="selected">No</option>
                                            <option [value]="true">Yes</option>
                                          </select>
                                        </div>
                                      </div>

                                      <div class="col-md-8" [style.display]="showCorrepSelect ? 'block' : 'none'">
                                        <div class="form-group">
                                          <label for="ddlAuthorList">Set Corresponding Author</label>
                                          <select id="ddlAuthorList" class="form-control " style="width: 100%;">
                                            <option [value]="0" selected="selected">Select</option>
                                            <option *ngFor="let author of lAuthorList" value={{author.ID}}>
                                              {{author.Surname}} {{author.Given_names}} {{author.Middlename}}
                                            </option>
                                          </select>
                                        </div>
                                      </div>

                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group" name="AUContributeIdType">
                                          <label for="txtContributeType">Contribute Id Type</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtContributeType" required>
                                        </div>
                                      </div>
                                      <div class="col-md-8">
                                        <div class="form-group" name="AUContributeId">
                                          <label for="txtContribute">Contribute Id</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtContribute" required>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group" name="AUORCID">
                                          <label for="txtAuORCID">ORCID</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAuORCID">
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group" name="AURinggoldId">
                                          <label for="txtAURinggoldId">Ringgold Id</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAURinggoldId">
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group" name="AURinggoldInstitution">
                                          <label for="txtAuRinggoldInstitution">Ringgold Institution</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAuRinggoldInstitution">
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group" name="AUAddress1">
                                          <label for="txtAuAddress1">Address1</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAuAddress1">
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group" name="AUAddress2">
                                          <label for="txtAuAddress2">Address2</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAuAddress2">
                                        </div>
                                      </div>
                                    </div>

                                    <div class="row">
                                      <div class="col-md-3">
                                        <div class="form-group" name="AUCity">
                                          <label for="txtAuCity">City</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAuCity">
                                        </div>
                                      </div>
                                      <div class="col-md-3">
                                        <div class="form-group" name="AUState">
                                          <label for="txtAuState">State</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAuState">
                                        </div>
                                      </div>
                                      <div class="col-md-3">
                                        <div class="form-group" name="AUCountry">
                                          <label for="txtAuCountry">Country</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAuCountry">
                                        </div>
                                      </div>
                                      <div class="col-md-3">
                                        <div class="form-group" name="AUPostalCode">
                                          <label for="txtAuPostalCode">Postal Code</label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAuPostalCode">
                                        </div>
                                      </div>
                                    </div>


                                  </div>
                                </form>
                              </div>
                            </div>
                            <!-- Modal footer -->
                            <div class="modal-footer">
                              <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideAuthorModal()">Close</button>
                              <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnUpdateAuthor" (click)="updateAuthorDetails()">Add / Update</button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="modal" id="myFundingModal" [style.display]="showFundingModal ? 'block' : 'none'">
                        <div class="modal-dialog modal-lg Author-modal">
                          <div class="modal-content" id="divFundingCT">
                            <!-- Modal Header -->
                            <div class="modal-header">
                              <h4 class="modal-title">Funding details</h4>
                              <div type="button" class="close" data-dismiss="modal" (click)="hideFundingModal()">×</div>
                            </div>
                            <!-- Modal body -->
                            <div class="modal-body" id="divFundingBody" style="overflow-x: scroll">
                              <div class="divTabContent">
                                <form #form="ngForm" id="frmFundingInfo">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label for="txtAwardGroupId">Award Group Id<em>*</em></label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAwardGroupId" required>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label for="txtAwardId">Award Id<em>*</em></label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtAwardId" required>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label for="txtInstitutionType">Institution Type<em>*</em></label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtInstitutionType" required>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label for="txtInstitutionId">Institution Id<em>*</em></label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtInstitutionId" required>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label for="txtInstitution">Institution<em>*</em></label>
                                          <input class="form-control" type="text" maxlength="1000" id="txtInstitution" required>
                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </form>
                              </div>
                            </div>
                            <!-- Modal footer -->
                            <div class="modal-footer">
                              <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideFundingModal()">Close</button>
                              <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnUpdateFunding" (click)="updateFundingDetails()">Add / Update</button>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div>

                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideInfoMetaDataModal()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="updateArticleDetails()" id="btnMetaUpdate">Update</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnReopen" style="display:none" (click)="ReopenArticlePopup()">Reopen</button>
                <button type="button" (click)="closeMetadataDetails()" style="display:none" id="btnCloseMetapopup">Close</button>
              </div>
            </div>
          </div>

          <div id="LoadingImageMeta">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
          </div>

        </div>

        <div class="modal" id="modalReopen" [style.display]="showReopenModal ? 'block' : 'none'">
          <div class="modal-dialog modal-lg Reopen-modal">
            <div class="modal-content" id="divFundingCT">
              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">Article Reopen</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hideReopenModal()">&times;</button>
              </div>
              <!-- Modal body -->
              <div class="modal-body" id="divReopenBody">
                <div class="divTabContent">

                  <div class="form-group col-6">
                    <button type="button" id="btnPublishedType" (click)="CheckPublishType()" style="display:none">Open</button>
                    <label for="ddlPublishedType">Is the article published?</label>
                    <select id="ddlPublishedType" class="form-control" style="width: 100%;" onchange="$('#btnPublishedType').trigger('click');">
                      <option value="Select" selected="selected">Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>

                  <div class="form-group col-6" id="divCheckVolIssue" style="display:none">
                    <button type="button" id="btnVolIssueChange" (click)="CheckVolIssueChange()" style="display:none">Open</button>
                    <label for="ddlChangeVolIssue">Do you want to change Vol/Issue?</label>
                    <select id="ddlChangeVolIssue" class="form-control" style="width: 100%;" onchange="$('#btnVolIssueChange').trigger('click');">
                      <option value="Select" selected="selected">Select</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>

                  <div id="divVolIssueUpdate" style="display:none">
                    <div class="col row">
                      <div class="col-2">
                        <label for="txtVolumeReopen">Volume</label>
                        <input class="form-control" type="text" maxlength="6" id="txtVolumeReopen" name="changeValueMeta">
                      </div>
                      <div class="col-2">
                        <label for="txtIssueReopen">Issue</label>
                        <input class="form-control" type="text" maxlength="6" id="txtIssueReopen" name="changeValueMeta">
                      </div>
                    </div>
                  </div>


                  <div class="form-group col-12" id="divCorrectionType" style="display:none">
                    <label>What is the correction type to be initiated?</label><br>


                    <div *ngFor="let item of lCorrectionTypeList">
                      <input type="radio" id="rdId_{{item.Id}}" name="correction_type" value="{{item.Id}} ">
                      <span>&nbsp;{{item.CorrectionType}}</span><br>
                    </div>

                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideReopenModal()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" id="btnUpdateFunding" (click)="updateReopenDetails()">Submit</button>

              </div>
            </div>
          </div>

          <div id="LoadingImageReopen">
            <img src="assets/Images/loader.gif" class="imgLoadimg" alt="" />
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
